import React, { Fragment } from 'react';
import Users from '../users/Users';

const Home = () => (
  <Fragment>
    <Users />
  </Fragment>
);

export default Home;
